/** File d’attente (5–8 lignes). */
import type { DashQueueItem } from "./types";

type QueueListProps = {
  title: string;
  empty: string;
  items?: DashQueueItem[];
  onMore?: () => void;
  onOpen?: (item: DashQueueItem) => void;
};

export function QueueList({ title, empty, items = [], onMore, onOpen }: QueueListProps) {
  return (
    <section className="fx-panel">
      <div className="fx-panel__head">
        <h2>{title}</h2>
        {onMore ? (
          <button type="button" className="fx-panel__more is-on" onClick={onMore}>
            Voir tout
          </button>
        ) : (
          <span className="fx-panel__more">Voir tout</span>
        )}
      </div>
      {items.length === 0 ? (
        <p className="fx-panel__empty">{empty}</p>
      ) : (
        <ul className="fx-dash-list">
          {items.map((row) => (
            <li key={row.id}>
              {onOpen && row.open ? (
                <button type="button" className="fx-dash-row" onClick={() => onOpen(row)}>
                  <strong>{row.title}</strong>
                  <span>{row.meta}</span>
                </button>
              ) : (
                <>
                  <strong>{row.title}</strong>
                  <span>{row.meta}</span>
                </>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
